import React, { useEffect, useState } from "react";
import { getMitgestaltenPage, getEinblicke } from "../lib/api";
import {
  Page,
  PageHeader,
  Section,
  SectionHead,
  IntroSplit,
  CardGrid,
  IconCard,
  PostFeed,
} from "../components/ui";

/**
 * Mitgestalten & Unterstützen — built entirely from the shared
 * library, no page-specific CSS:
 *   PageHeader  → title + subtitle
 *   IntroSplit  → image + kicker + blue title + both intro paragraphs
 *   SectionHead + CardGrid/IconCard → ways to get involved
 *   SectionHead + PostFeed → parent posts (filtered Einblicke)
 *
 * Spacing comes from the shared rhythm in tokens.css, the same as
 * every other page.
 */
export default function MitgestaltenUnterstuetzenPage() {
  const [page, setPage] = useState(null);
  const [entries, setEntries] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    Promise.all([getMitgestaltenPage(), getEinblicke()])
      .then(([pageRes, entriesRes]) => {
        if (cancelled) return;
        setPage(pageRes);
        setEntries(entriesRes);
      })
      .catch((err) => {
        if (!cancelled) setError(err);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const {
    heroTitle,
    heroSubtitle,
    heroImage,
    introKicker,
    introTitle,
    introText1,
    introText2,
    noteSectionTitle,
    noteSectionText,
    carouselKicker,
    carouselTitle,
    carouselCategory,
    cards,
  } = page || {};

  return (
    <Page loading={!page} error={error}>
      <PageHeader
        parent={{ label: "Eltern & Schule" }}
        current="Mitgestalten & Unterstützen"
        title={heroTitle || "Mitgestalten & Unterstützen"}
        subtitle={heroSubtitle}
      />

      <Section intro>
        <IntroSplit
          image={heroImage}
          kicker={introKicker}
          title={introTitle}
          text={[introText1, introText2]}
        />
      </Section>

      {cards?.length > 0 && (
        <Section>
          <SectionHead title={noteSectionTitle} subtitle={noteSectionText} />

          <CardGrid cols={3}>
            {cards.map((card, i) => (
              <IconCard
                key={card.id ?? i}
                iconName={card.iconName}
                title={card.title}
                text={card.text}
                headingLevel={3}
              />
            ))}
          </CardGrid>
        </Section>
      )}

      <Section>
        <SectionHead kicker={carouselKicker} title={carouselTitle} />

        <PostFeed
          entries={entries}
          category={carouselCategory || "Eltern"}
          queryParam="beitrag"
        />
      </Section>
    </Page>
  );
}